import styled from "styled-components";

export const LandingPageContainer = styled.div<{ isCPPPromo: boolean }>`
  width: 100%;
  background: var(--fd-colors-background-surface);
  overflow-y: auto;

  @media only screen and (min-width: 768px) {
    [data-qa-label="promosFooterContainer"] {
      margin-top: 40px;
    }
  }

  @media only screen and (max-width: 767px) {
    padding-bottom: 58px;

    [data-qa-label="promosFooterContainer"] {
      margin-top: 16px;
    }
  }

  @media only screen and (min-device-width: 1025px) and (orientation: landscape) {
    max-width: inherit;
  }
`;

export const OptinFooterBtnWrapper = styled.div`
  position: fixed;
  transform: translate3d(0, 0, 0);
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--fd-colors-background-surface);
  min-height: calc(46px + constant(safe-area-inset-bottom));
  min-height: calc(46px + env(safe-area-inset-bottom));
  padding: 12px;
  box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.2);
  z-index: 101;

  > div {
    &.promosOptInButton {
      margin: 0;

      button,
      a {
        width: 100%;
      }
    }
  }

  @media only screen and (min-width: 600px) {
    display: none;
  }
`;
